import { useState } from "react";
import { Popover } from "@mui/material";
import { FaCalendarAlt } from "react-icons/fa";
import dayjs from "dayjs";

import VuiBox from "components/VuiBox";
import VuiButton from "components/VuiButton";
import VuiInput from "components/VuiInput";
import VuiTypography from "components/VuiTypography";

function MonthSelector({
  value = "",
  onChange,
  label = "Select Month",
  placeholder = "All Months",
  width = 160,
  clearable = true,
}) {
  const [anchorEl, setAnchorEl] = useState(null);

  const open = Boolean(anchorEl);

  return (
    <>
      <VuiButton
        variant="outlined"
        color="primary"
        size="small"
        onClick={(e) => setAnchorEl(e.currentTarget)}
        sx={{
          minWidth: width,
          justifyContent: "center",
        }}
      >
        <VuiBox display="flex" alignItems="center" gap={1}>
          <FaCalendarAlt size={12} />

          <VuiTypography variant="caption">
            {value ? dayjs(value).format("MMMM YYYY") : placeholder}
          </VuiTypography>
        </VuiBox>
      </VuiButton>

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        PaperProps={{
          sx: {
            mt: 1,
            borderRadius: "20px",
            minWidth: 280,

            background: "rgba(255,255,255,0.04)",
            backdropFilter: "blur(24px)",
            WebkitBackdropFilter: "blur(24px)",

            border: "1px solid rgba(255,255,255,0.08)",
            boxShadow: "0 8px 32px rgba(0,0,0,0.25)",

            overflow: "hidden",
          },
        }}
      >
        <VuiBox px={0.5} py={0.5}>
          <VuiTypography variant="h6" fontWeight="regular" mb={1} ml={1}>
            {label}
          </VuiTypography>

          <VuiInput
            gradient
            type="month"
            fullWidth
            value={value}
            onChange={(e) => onChange?.(e.target.value)}
          />

          <VuiBox display="flex" justifyContent="end" mt={2}>
            {clearable && (
              <VuiButton
                variant="outlined"
                color="primary"
                size="small"
                onClick={() => {
                  onChange?.("");
                  setAnchorEl(null);
                }}
              >
                Clear
              </VuiButton>
            )}

            {/* <VuiButton color="primary" size="small" onClick={() => setAnchorEl(null)}>
              Apply
            </VuiButton> */}
          </VuiBox>
        </VuiBox>
      </Popover>
    </>
  );
}

export default MonthSelector;
